import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NEW_DASHBOARD_TEMPLATE_ID } from "../constants";
var translation = /*#__PURE__*/_defineProperty({}, NEW_DASHBOARD_TEMPLATE_ID, {
  GENERAL_ERROR: 'Ocorreu um erro',
  TRY_AGAIN: 'Tente novamente',
  SEARCH_LABEL: 'O que você está procurando no seu painel?',
  INTERNET_CONNECTION_ERROR: 'Ocorreu um erro de conexão',
  RELOAD_PAGE: 'Recarregue a página',
  BUTTON_COLLAPSE_SIDEBAR_OPENED: 'Recolher menu',
  BUTTON_COLLAPSE_SIDEBAR_CLOSED: 'Expandir menu',
  GO_TO_OLD_HOME_SNACKBAR_CTA: 'Voltar para a versão antiga',
  PRODUCT: 'Producto'
});
export default translation;